/**
 * Shared success-message copy so modals/forms across the app phrase
 * confirmations consistently instead of each hardcoding its own string.
 */
export const SUCCESS_MESSAGES = {
  CATEGORY_CREATED: 'Category created successfully.',
  DOCUMENT_TYPE_CREATED: 'Document type created successfully.',
  DOCUMENT_UPLOADED: 'Document uploaded successfully.',
  DOCUMENT_UPDATED: 'Document updated successfully.',
  VERSION_REPLACED: 'New version uploaded successfully.',
} as const;
